module.exports = {"partners":{"des":"合作伙伴图标，将图片文件放在index文件夹中","img":["partner1.png","partner2.png","partner3.png","partner4.png","partner5.png","partner6.png"]}}


//////////////////
// WEBPACK FOOTER
// ./static/json/partner.json
// module id = VXaT
// module chunks = 0